import { AxiosError } from 'axios';
import useSWR, { SWRResponse } from 'swr';
import { useRecoilValue } from 'recoil';
import { authState } from '@/stores/authStore';
import { authFetcher } from '@/core/http';
import { useUser } from '@/services/userService';
import {
  GetBillingInvoicesResponse,
  parseBillingInvoicesResponse,
} from './billingTypes';

export const BILLING_INVOICES_SWR_KEY = '/billing/invoices';

const billingInvoicesFetcher = ([url, token]: [
  string,
  string
]): Promise<GetBillingInvoicesResponse> =>
  authFetcher([url, token]).then(parseBillingInvoicesResponse);

export function useBillingInvoices(): SWRResponse<
  GetBillingInvoicesResponse,
  AxiosError
> {
  const { token, isGuestToken } = useRecoilValue(authState);
  const { data: user } = useUser();

  const isEligible = !isGuestToken && !!token && !!user;

  return useSWR<GetBillingInvoicesResponse, AxiosError>(
    isEligible ? [BILLING_INVOICES_SWR_KEY, token] : null,
    billingInvoicesFetcher
  );
}
